import React, { ChangeEvent } from 'react'
import { TextField, SelectChangeEvent, TextFieldProps } from '@mui/material';
import { useThemeContext } from '../../theme/ThemeContext';
import Selector, { SelectorProps } from '../Selector'

interface EntityFieldProps<Entity> {
  children?: React.ReactNode
  label: string
  entity: Entity
  attr: keyof Entity
  //TODO: Use TextFieldProps
  required?: boolean
  disabled?: boolean
}

export const entityTextField = <T extends {}>(change: (newEntity: T) => void): React.FC<EntityFieldProps<T> & TextFieldProps> =>
  ({ label, entity, attr, ...props }) => {
    const { theme } = useThemeContext()
    return <TextField
      sx={{
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: theme.palette.action.disabled
        },
        "& .MuiFormLabel-root.Mui-disabled": {
          color: theme.palette.action.disabled,
        }
      }}
      label={label}
      margin="normal"
      value={entity[attr] || ''}
      onChange={onChangeTextField(change, entity, attr)}
      fullWidth
      {...props}
    />
  }

export const entitySelectField = <T extends {}>(change: (newEntity: T) => void): React.FC<SelectorProps & EntityFieldProps<T>> =>
  ({ label, entity, attr, children, ...props }) =>
    <Selector
      {...props}
      label={label}
      style={{ ...props.style, flexGrow: 1 }}
      value={entity[attr] as any}
      required={props.required}
      onChange={onChange(change, entity, attr)}
    />

export const entitySmallTextField = <T extends {}>(change: (newEntity: T) => void): React.FC<EntityFieldProps<T> & TextFieldProps> =>
  ({ label, entity, attr, ...props }) => {
    const { theme } = useThemeContext()
    return <TextField
      sx={{
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: theme.palette.action.disabled
        },
        "& .MuiFormLabel-root.Mui-disabled": {
          color: theme.palette.action.disabled,
        }
      }}
      label={label}
      margin="dense"
      value={entity[attr] || ''}
      onChange={onChangeTextField(change, entity, attr)}
      size="small"
      variant="outlined"
      fullWidth
      {...props}
    />
  }


const onChangeTextField = <Entity extends {}>(change: (newEntity: Entity) => any, entity: Entity, attr: keyof Entity) => (event: ChangeEvent<{ value }>) => {
  event.preventDefault()
  change({ ...entity, [attr]: event.target.value })
}
const onChange = <Entity extends {}>(change: (newEntity: Entity) => any, entity: Entity, attr: keyof Entity) => (event: SelectChangeEvent<{ value }>) => {
  event.preventDefault()
  change({ ...entity, [attr]: event.target.value })
}